import React from "react";

import SiteNav from "components/Redesign/SiteNav.js";
import SiteFooter from "components/Redesign/SiteFooter.js";
import { COMPANY_NAME, CONTACT_EMAIL, LEGAL_LAST_UPDATED } from "components/Redesign/legalData.js";

function Datenschutz() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rd">
      <SiteNav />

      <section className="page-shell">
        <div className="wrap">
          <div className="rd-section-no">Rechtliches</div>
          <h1 className="page-shell-h1">Datenschutzerklärung</h1>

          <div className="legal-body">
            <p>
              Wir bearbeiten Personendaten nach dem Schweizer Datenschutzgesetz (DSG). Diese
              Erklärung sagt dir, welche Daten wir erheben, wozu wir sie verwenden und welche
              Rechte du hast.
            </p>

            <h2>Verantwortliche Stelle</h2>
            <p>{COMPANY_NAME}</p>
            <p>
              E-Mail: <span className="legal-mail">{CONTACT_EMAIL}</span>
            </p>

            <h2>Welche Daten wir bearbeiten</h2>
            <p>
              <strong>Bestellung.</strong> Wenn du über das Bestellformular bestellst, erheben wir
              Name, Adresse, PLZ, Ort, E-Mail-Adresse, Telefonnummer sowie einen allfälligen
              Kommentar. Wir verwenden diese Angaben ausschliesslich, um deine Bestellung
              abzuwickeln, den Versand auszulösen und bei Rückfragen mit dir Kontakt
              aufzunehmen.
            </p>
            <p>
              <strong>Newsletter.</strong> Meldest du dich für den Newsletter an, speichern wir
              deine E-Mail-Adresse. Du kannst dich jederzeit formlos per E-Mail wieder abmelden.
            </p>
            <p>
              <strong>Aufruf der Website.</strong> Beim Besuch der Website werden technisch
              notwendige Verbindungsdaten wie deine IP-Adresse verarbeitet. Wir setzen weder
              Analyse- noch Trackingdienste ein und erstellen keine Nutzerprofile.
            </p>

            <h2>Cookies und lokale Speicherung</h2>
            <p>
              Wir verwenden keine Werbe- oder Analyse-Cookies. Gespeichert wird lediglich deine
              gewählte Sprache, damit die Website beim nächsten Besuch in derselben Sprache
              erscheint.
            </p>

            <h2>Weitergabe an Dritte</h2>
            <p>
              Wir verkaufen keine Daten. Für den Betrieb der Website nutzen wir jedoch folgende
              Dienste, die dabei technisch bedingt deine IP-Adresse und teilweise die von dir
              eingegebenen Daten verarbeiten. Ein Teil dieser Anbieter hat Sitz in den USA:
            </p>
            <ul>
              <li>
                <strong>EmailJS</strong> – übermittelt die Angaben aus dem Bestell- und
                Newsletterformular an unser E-Mail-Postfach.
              </li>
              <li>
                <strong>Google</strong> – reCAPTCHA schützt das Newsletterformular vor Missbrauch,
                zusätzlich laden wir Schriftarten über Google Fonts.
              </li>
              <li>
                <strong>YouTube</strong> – auf der Seite «Live vom Bienenstock» ist ein Video
                eingebettet. Wir nutzen den erweiterten Datenschutzmodus, YouTube setzt
                Cookies also erst, wenn du das Video abspielst.
              </li>
              <li>
                <strong>ThingSpeak (MathWorks)</strong> – zeigt die Diagramme unserer Stockwaagen an.
              </li>
              <li>
                <strong>Open-Meteo</strong> – liefert die Wetterdaten für den Wetterstatus auf der
                Startseite.
              </li>
              <li>
                <strong>Content Delivery Networks</strong> (jsDelivr, cdnjs, Font Awesome) – liefern
                Schriften und Programmbibliotheken aus.
              </li>
            </ul>

            <h2>Aufbewahrung</h2>
            <p>
              Bestelldaten bewahren wir so lange auf, wie es für die Abwicklung nötig ist und die
              gesetzlichen Aufbewahrungsfristen es verlangen (für Geschäftsunterlagen zehn Jahre
              nach Obligationenrecht). Danach löschen wir sie.
            </p>

            <h2>Deine Rechte</h2>
            <p>
              Du kannst jederzeit Auskunft darüber verlangen, welche Daten wir über dich bearbeiten,
              und deren Berichtigung oder Löschung fordern. Eine formlose E-Mail an{" "}
              <span className="legal-mail">{CONTACT_EMAIL}</span> genügt.
            </p>

            <p className="legal-updated">Stand: {LEGAL_LAST_UPDATED}</p>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}

export default Datenschutz;
